/**
 * Fetch the classifier metadata sidecar (`doc-cnn.json`) the trainer publishes.
 * Browser/fetch-based; a Lambda can build a {@link ClassifierMeta} directly.
 */
import { ClassifierMeta } from './types';

/** Fetch + parse the classifier meta JSON (default 'doc-cnn.json', site root). */
export async function loadClassifierMeta(url = 'doc-cnn.json'): Promise<ClassifierMeta> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to load classifier meta from ${url}: ${res.status}`);
  return (await res.json()) as ClassifierMeta;
}
